import { render } from "./Ordering.vue?vue&type=template&id=22d87bef"
import script from "./Ordering.vue?vue&type=script&lang=js"
export * from "./Ordering.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__